import React from "react";
import { Link as RouterLink } from "react-router-dom";

const geist = { fontFamily: "'Geist', sans-serif" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };

const OPEN_ACCOUNT_URL = "https://zikoramfb.qoreonline.com/onboarding/type";

const AdvisorCta = () => {
  return (
    <>
      <style>{`
        .sme-cta-buttons { flex-wrap: nowrap !important; }
        .sme-cta-buttons a { white-space: nowrap; }
        @media (max-width: 767px) {
          .sme-cta-card { padding: 44px 20px !important; }
          .sme-cta-buttons { gap: 10px !important; }
          .sme-cta-buttons a { padding: 0 16px !important; }
        }
        @media (max-width: 400px) {
          .sme-cta-buttons a { padding: 0 12px !important; font-size: 13px !important; }
        }
      `}</style>

      <section
        style={{
          width: "100%",
          backgroundColor: "transparent",
          boxSizing: "border-box",
          padding: "0 clamp(20px, 5.56vw, 80px) clamp(56px, 6.94vw, 100px)",
        }}
      >
        <div
          className="sme-cta-card"
          style={{
            maxWidth: "1280px",
            margin: "0 auto",
            backgroundColor: "#132A22",
            borderRadius: "20px",
            boxSizing: "border-box",
            padding: "clamp(56px, 7vw, 96px) clamp(24px, 4vw, 64px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "32px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
              maxWidth: "640px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#86C7A8",
                  flexShrink: 0,
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  ...geistMono,
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: 1,
                  letterSpacing: "0.1em",
                  color: "#86C7A8",
                  textTransform: "uppercase",
                }}
              >
                SME Advisor
              </span>
            </div>

            <h2
              style={{
                ...instrumentSerif,
                fontWeight: 400,
                fontSize: "clamp(32px, 4.17vw, 56px)",
                lineHeight: 1.1,
                letterSpacing: "-0.01em",
                color: "#FFFFFF",
                margin: 0,
              }}
            >
              Need help choosing the right business solution?
            </h2>

            <p
              style={{
                ...geist,
                fontWeight: 400,
                fontSize: "clamp(14px, 1.25vw, 18px)",
                lineHeight: 1.7,
                color: "#C9D6CE",
                margin: 0,
                maxWidth: "560px",
              }}
            >
              Speak directly with an SME Advisor for guidance on accounts,
              loans, POS solutions, and business support. Real people, based in
              the East, who know your market.
            </p>
          </div>

          <div
            className="sme-cta-buttons"
            style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}
          >
            <a
              href={OPEN_ACCOUNT_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                ...geist,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: "52px",
                padding: "0 24px",
                backgroundColor: "#86C7A8",
                borderRadius: "8px",
                fontWeight: 600,
                fontSize: "clamp(13px, 1.11vw, 16px)",
                color: "#132A22",
                textDecoration: "none",
              }}
            >
              Open Account
            </a>
            <RouterLink
              to="/contact"
              style={{
                ...geist,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: "52px",
                padding: "0 24px",
                backgroundColor: "transparent",
                border: "1px solid rgba(222, 222, 222, 0.4)",
                borderRadius: "8px",
                fontWeight: 600,
                fontSize: "clamp(13px, 1.11vw, 16px)",
                color: "#FFFFFF",
                textDecoration: "none",
              }}
            >
              Talk to an SME Advisor
            </RouterLink>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdvisorCta;
